<template>
  <div id="anwesenheiten-export-modal" class="modal fade">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <modal-close-button @confirmed="closeModal" />
          <h4 class="modal-title">{{ $t("global.attendenceexport") }}</h4>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            {{ $t("global.infotextexport") }}
          </div>
          <div class="row">
            <div class="col-lg-12 col-xl-6">
              <div class="form-group">
                <date-picker
                  date-format="dd.mm.yy"
                  :initial="localVon"
                  @update="(val) => (localVon = val)"
                  :show-icon="true"
                  :inModal="true"
                />
                <label>{{ $t("global.from") }}</label>
              </div>
            </div>
            <div class="col-lg-12 col-xl-6">
              <div class="form-group">
                <date-picker
                  date-format="dd.mm.yy"
                  :initial="localBis"
                  @update="(val) => (localBis = val)"
                  :show-icon="true"
                  :inModal="true"
                />
                <label>{{ $t("global.till") }}</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <single-select-person
                id="student"
                :person="person"
                :allowOpen="false"
                :activeonly="true"
                :label="$t('global.person')"
                editable
                @confirmed="setPerson"
              />
            </div>
            <div class="col-6">
              <single-select-veranstaltung
                id="anwesenheiten-exoprt-veranstaltung"
                :label="$t('global.event')"
                :activeonly="true"
                :allowOpen="false"
                :veranstaltung="veranstaltung"
                editable
                @confirmed="setVeranstaltung"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-danger" @click="closeModal">
            {{ $t("global.cancel") }}
          </button>
          <button class="btn btn-success" @click="getCarboneExport">
            {{ $t("global.export") }}
          </button>
        </div>
      </div>
    </div>
    <loading-overlay v-show="loading"></loading-overlay>

  </div>
</template>

  <script>
import Api from "@/api/Api";
import CarboneApi from "@/api/CarboneApi";
import ModalCloseButton from "@/components/global/ModalCloseButton";
import DatePicker from "@/components/Datepicker";
import page from "@/mixins/Page";
import SingleSelectPerson from "@/components/global/SingleSelectPerson.vue";
import SingleSelectVeranstaltung from "@/components/global/SingleSelectVeranstaltung.vue";
import FileDownload from "js-file-download";
import server from "@/server";

export default {
  name: "AnwesenheitenExportModal",
  components: {
    ModalCloseButton,
    DatePicker,
    SingleSelectPerson,
    SingleSelectVeranstaltung,
  },
  metaInfo() {},
  mixins: [page],
  props: {
    id: {
      type: String,
      required: true,
    },
    person: {
      type: Object,
      required: false,
      default: null,
    },
    veranstaltung: {
      type: Object,
      required: false,
      default: function () {
        return { bezeichnung: this.$t("global.notlinked") };
      },
    },
    termin: {
      type: String,
      required: false,
      default: null,
    },
    von: {
      type: String,
      required: false,
      default: null,
    },
    bis: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      localVon: this.von,
      localBis: this.bis,
      shown: false,
    };
  },
  watch: {
    von(newValue) {
      this.localVon = newValue; // Falls der Parent die Prop ändert, synchronisieren
    },
    bis(newValue) {
      this.localBis = newValue;
    },
  },
  mounted: function () {
    this.$bus.$on("openAnwesenheitenExportModal", () => {
      if (!this.shown) this.openModal();
    });
  },
  methods: {
    getCarboneExport() {
      this.loading = true;

      let params = {};

      let json = {
        person: this.person ? this.person.id : null,
        veranstaltung: this.veranstaltung ? this.veranstaltung.id : null,
        termin: this.termin ? this.termin : null,
        von: this.localVon ? this.localVon : null,
        bis: this.localBis ? this.localBis : null,
      };

      if (this.person) params.person = this.person.id;
      if (this.veranstaltung) params.veranstaltung = this.veranstaltung.id;
      if (this.termin) params.termin = this.termin;
      if (this.localVon) params.von = this.localVon;
      if (this.localBis) params.bis = this.localBis;

      CarboneApi.post("carbone-anwesenheiten-export/", json, { params })
        .then((response) => {
          if (this.isDisplayableFile(response.data[0]?.url) === "isWordFile") {
            $;
            response.data.forEach((file) => {
              this.saveFile(
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                file.url,
                file.name,
                ".docx"
              );
            });
          } else if (
            this.isDisplayableFile(response.data[0]?.url) === "isExcelFile"
          ) {
            response.data.forEach((file) => {
              this.saveFile(
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                file.url,
                file.name,
                ".xlsx"
              );
            });
          } else {
            this.pdfFiles = response.data.map((item) => ({
              url: server.url + item.url,
              name: item.name,
              count: item.count,
              size: item.name,
            }));

            this.pdfFiles.length > 0
              ? this.$refs.pdfLayerAnmeldungReiter.show()
              : this.$notify({
                  type: "warn",
                  title: this.$t("global.actionfailed"),
                  text: "Es ist ein Fehler aufgetreten",
                });
          }
        })
        .catch((e) => {
          this.$notify({
            type: "warn",
            title: this.$t("global.actionfailed"),
            text: this.$t("global.exportfailed"),
          });
        })
        .finally(() => {
          this.loading = false;
          this.closeModal();
        });
    },

    isDisplayableFile(url) {
      const fileExtension = this.getFileExtension(url);
      if (["docx", "doc"].includes(fileExtension)) {
        return "isWordFile";
      } else if (["xls", "xlsx", "xlsm"].includes(fileExtension)) {
        return "isExcelFile";
      }
      return "isDisplayable";
    },
    getFileExtension(url) {
      const parts = url?.split(".");
      return parts[parts.length - 1].toLowerCase();
    },
    async saveFile(contentType, url, fileName, type) {
      if (!contentType || !url) return;

      if (!fileName) fileName = "Report";
      fileName = fileName + type;

      const response = await fetch(Api.defaults.defaultURL + url, {
        headers: {
          "Content-Type": contentType,
        },
      });

      let file = await response.blob();
      FileDownload(file, fileName);
    },

    openModal() {
      $("#anwesenheiten-export-modal").modal({
        backdrop: "static",
        keyboard: false,
      });

      this.shown = false;
    },

    closeModal() {
      $("#anwesenheiten-export-modal").modal("hide");
    },

    setVeranstaltung(veranstaltung) {
      this.veranstaltung = veranstaltung;
    },

    setPerson(person) {
      this.person = person;
    },
  },
};
</script>

  <style></style>
